import { AbTestV2Func } from '../../server/types/dblRouteHandlerArgs';
import { NO_CACHE, SHORT_CACHE, STANDARD_CACHE } from '../../../exports/cacheHeaderEnums';
import { DibsCacheTypes } from '../../server/types/server';
import { getAbTestV2 } from 'dibs-ab-tests/exports/clientAbTestV2';

export const PERSONALIZED_RERANK_TEST_NAME = 'Personalized-Rerank' as const;

const isPersonalizedRerankAbTestVariantServer = (getAbTest: AbTestV2Func): boolean =>
    getAbTest(PERSONALIZED_RERANK_TEST_NAME)?.variant === 'variant';

export const isPersonalizedRerankAbTestVariant = (): boolean =>
    getAbTestV2(PERSONALIZED_RERANK_TEST_NAME)?.variant === 'variant';

type Props = { getAbTestV2: AbTestV2Func };

export const standardOrNoCache = ({ getAbTestV2: getAbTestServer }: Props): DibsCacheTypes =>
    isPersonalizedRerankAbTestVariantServer(getAbTestServer) ? NO_CACHE : STANDARD_CACHE;

export const shortOrNoCache = ({ getAbTestV2: getAbTestServer }: Props): DibsCacheTypes =>
    isPersonalizedRerankAbTestVariantServer(getAbTestServer) ? NO_CACHE : SHORT_CACHE;
